export default "__VITE_ASSET__4dc24b74__"